enum MutationKeys {
  CreateBankAccount = 'createBankAccount',
  SetupBankAccountsFromConnection = 'setupBankAccountsFromConnection',
  CreateTransaction = 'createTransaction',
  SetTarget = 'setTarget',
  CreateOrUpdatePlan = 'createOrUpdatePlan',
}

export default MutationKeys
